import { associateActionIcon } from '../../../helpers/dataTableActionIconHelper'
import { ActionIcons } from '../../../model'
import { QuantityDataTableRow } from './quantityDataTable.model'

//map row Icons if row has tempId
export const mapDataTableRowIcons = (
  dataTableRows: QuantityDataTableRow[] | null | undefined
): any => {
  if (dataTableRows) {
    return dataTableRows.map(p => {
      const actionIcon = p.tempId
        ? associateActionIcon(p, ActionIcons.NEW_ITEM, 'No Guardado')
        : undefined
      return { ...p, actions: actionIcon }
    })
  }
  return dataTableRows
}
